import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MessageData, MessageService } from './message.service';

@Component({
  selector: 'rav-message',
  templateUrl: './message.component.html'
})
export class MessageComponent implements OnInit, OnDestroy {
  @Input() id: string;
  isVisible = false;
  data: MessageData = {};
  messageStateSubscription: Subscription;

  constructor(public message: MessageService) {}

  ngOnInit() {
    this.messageStateSubscription = this.message.state$.subscribe((state) => {
      if (state.id !== this.id) return;
      if (state.hideAll) this.isVisible = false;
      if (state.isVisible !== null) this.isVisible = state.isVisible;
      this.data = {
        ...this.data,
        ...state.data
      };
    });
  }

  ngOnDestroy() {
    this.messageStateSubscription.unsubscribe();
  }
}
